import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const GLOBAL_SETTINGS_URL = `${SERVER_API}/global-settings`;

export const NOTIFICATION_RECIPIENTS_URL = `${SERVER_API}/notification/recipients`;

export const GLOBAL_SETTINGS = {
  TMC_PROVIDED_PERIOD_DAYS_GET: {
    method: 'GET',
    url: `${GLOBAL_SETTINGS_URL}/tmc-provided-period-days`,
  } as IEndpointData,
  TMC_PROVIDED_PERIOD_DAYS_UPDATE: {
    method: 'PUT',
    url: `${GLOBAL_SETTINGS_URL}/tmc-provided-period-days`,
  } as IEndpointData,
};
